import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var FacebookLogoIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    d: "M16.623 2.004L14.225 2C11.53 2 9.789 3.932 9.789 6.922v2.27H7.377c-.208 0-.377.182-.377.407v3.288c0 .226.169.408.377.408H9.79v8.297c0 .226.169.408.377.408h3.146c.209 0 .378-.183.378-.408v-8.297h2.82c.208 0 .377-.182.377-.408V9.6a.426.426 0 00-.11-.288.364.364 0 00-.267-.12h-2.82V7.268c0-.925.203-1.394 1.317-1.394l1.616-.001c.208 0 .377-.183.377-.408V2.412c0-.225-.169-.407-.377-.408z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(FacebookLogoIcon);